import { handleActions } from "redux-actions";
import {
  GET_PLACEMENT_CATEGORIES_SUCCESS,
  ADD_PLACEMENT_CATEGORY_SUCCESS,
  UPDATE_PLACEMENT_CATEGORY_SUCCESS,
  DELETE_PLACEMENT_CATEGORY_SUCCESS,
} from "../../constants/actionTypes";

const initialState = {
  categories: [],
  loading: false,
  error: null,
};

export default handleActions(
  {
    [GET_PLACEMENT_CATEGORIES_SUCCESS]: (state, { payload }) => ({
      ...state,
      categories: payload.data || [],
      loading: false,
      error: null,
    }),
    [ADD_PLACEMENT_CATEGORY_SUCCESS]: (state, { payload }) => ({
      ...state,
      categories: [...state.categories, payload.data],
      loading: false,
      error: null,
    }),
    [UPDATE_PLACEMENT_CATEGORY_SUCCESS]: (state, { payload }) => ({
      ...state,
      categories: state.categories.map((category) =>
        category.id === payload.data.id ? payload.data : category
      ),
      loading: false,
      error: null,
    }),
    [DELETE_PLACEMENT_CATEGORY_SUCCESS]: (state, { payload }) => ({
      ...state,
      categories: state.categories.filter(
        (category) => category.id !== payload.data.id
      ),
      loading: false,
      error: null,
    }),
  },
  initialState
);
